import { useState } from "react"
import { Button } from "@/components/ui/button"

interface AsyncButtonProps extends React.ComponentProps<typeof Button> {
  onClick: () => Promise<void>;
}

export function AsyncButton({ onClick, children, ...props }: AsyncButtonProps) {
  const [loading, setLoading] = useState(false)

  async function handleClick() {
    setLoading(true)
    await onClick()
    setLoading(false)
  }

  return (
    <Button onClick={handleClick} disabled={loading} {...props}>
      {children}
    </Button>
  )
}
